import { styled } from "@mui/material";
import MuiTextField from "@mui/material/TextField";

const AutocompleteTextField = styled(MuiTextField)(({ theme }) => ({
  "& .MuiButtonBase-root.Mui-disabled": {
    opacity: 0.4,
  },
  "& .MuiInput-root.MuiInputBase-sizeSmall .MuiInput-input": {
    padding: "4px 0 5px",
  },
  "& input": {
    caretColor: theme.palette.secondary1[100],
    "::placeholder": {
      opacity: 1,
      color: theme.palette.grey[100],
      fontSize: "14px",
      fontWeight: 400,
    },
  },
  "& .Mui-disabled:before": {
    borderBottomStyle: "solid",
  },
  "& .MuiInput-underline": {
    marginTop: "21px",

    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(0),
    "&.MuiInputBase-sizeSmall": {
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0),
    },
  },
  "& .MuiOutlinedInput-root": {
    "&.MuiInputBase-sizeSmall": {
      paddingTop: theme.spacing(0.5) + "!important",
      paddingBottom: theme.spacing(0.5) + "!important",
      paddingLeft: theme.spacing(0.75),
    },
    minHeight: 34,
    borderRadius: theme.shape.borderRadiusSmall,
    minWidth: 120,
    "& .MuiInputBase-sizeSmall input": {
      height: "15px",
    },
    "& fieldset": {
      borderColor: theme.palette.grey[60],
    },
  },
  variants: [
    {
      props: { size: "xl", variant: "standard" },
      style: {
        "& .MuiInputBase-root:not(.MuiOutlinedInput-root) input.MuiInputBase-input.MuiInput-input": {
          padding: theme.spacing(0, 0.5, 0, 0),
          fontSize: "20px",
          height: "28px",
          width: "fit-content",
        },
      },
    },
    {
      props: { size: "xl", variant: "outlined" },
      style: {
        height: "29px",
        "& .MuiInputBase-root.MuiInputBase-sizeXl.MuiOutlinedInput-root input.MuiInputBase-input.MuiOutlinedInput-input":
          {
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            fontSize: "20px",
          },
        "& .MuiOutlinedInput-root": {
          minHeight: "20px",
        },
      },
    },
  ],
}));
export default AutocompleteTextField;
